import React from 'react';
import Box from "@mui/material/Box";
import GeneralShop from "./GeneralShop";
import {contentTexts} from "../ContentText";

function ShopSection(props) {
    return (
        <Box className={"flexColumnCenter"} sx={{width: '100%',
        }}
             ref={props.refs}>
            <p className={"toptitle"}>Einzelleistungen</p>
            <p className={"subtitle"}>Passgenau für dich</p>
            <GeneralShop sx={{width: "100%", marginTop: "150px", marginBottom: "40px"}}
                         data={contentTexts.singleActionsContent}></GeneralShop>
        </Box>
    );
}

export default ShopSection;